import Checkbox from './Checkbox';
import { getOptionProps } from '../_util/props-util';

export default {
  name: 'ACheckboxButton',
  props: {
    ...Checkbox.props,
    prefixCls: {
      default: 'ant-checkbox-button',
      type: String,
    },
  },
  inject: {
    checkboxGroupContext: { default: undefined },
  },
  render() {
    const props = getOptionProps(this);
    const checkboxProps = { props, on: { ...this.$listeners } };
    if (this.checkboxGroupContext) {
      checkboxProps.on.change = this.checkboxGroupContext.$listeners.change;
      checkboxProps.props.checked = this.checkboxGroupContext.sValue.indexOf(props.value) !== -1;
      checkboxProps.props.disabled = props.disabled || this.checkboxGroupContext.disabled;
    }
    return <Checkbox {...checkboxProps}>{this.$slots.default}</Checkbox>;
  },
};
